
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/the-imposter-syndrome",
      function () {
        return require("private-next-pages/articles/the-imposter-syndrome.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/the-imposter-syndrome"])
      });
    }
  